import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import Button from '@hfe/max-button';
import NoticeSlider from '../notice-slider';
import LandmarkCard from './landmark-card';
import { computeProgress, formatProgress } from '../../utils/number';
import { FREE_CARD_AMOUNT } from '../../const';
import { PRE_JOINED_ASSET } from './assets';
import './index.scss';
function PreJoinedCardV1(props) {
    const rawProgress = computeProgress(props.currentScore, props.totalScore);
    const currentProgress = formatProgress(rawProgress);
    const remainProgress = formatProgress(Math.max(0, 100 - rawProgress));
    const fillWidth = `${Math.max(2, Math.min(100, Math.round(rawProgress)))}%`;
    const btnText = props.feConfig?.preJoinedConfig?.btnText || '开启城市探索进度';
    const { styleConfig } = props.feConfig ?? {};
    return <View className="pre-joined-v1" style={{
        backgroundColor: styleConfig?.backgroundColor
    }}>
      <LinearGradient colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} className="pre-joined-v1__bg"/>

      <View className="pre-joined-v1__content">
        
        <View className="pre-joined-v1__header">
          <View className="pre-joined-v1__title">
            <Text className="pre-joined-v1__title-text" numberOfLines={1}>邀好友攒进度 领</Text>
            <Text className="pre-joined-v1__title-amount" numberOfLines={1}>{`${FREE_CARD_AMOUNT}元`}</Text>
            <Text className="pre-joined-v1__title-text" numberOfLines={1}>{`${props.currentCityName}免单卡`}</Text>
          </View>
          <Button className="pre-joined-v1__reselect" onPress={() => props.onReSelect()}>
            <Text className="pre-joined-v1__reselect-text" numberOfLines={1}>更换城市</Text>
            <Image className="pre-joined-v1__reselect-arrow" source={{
        uri: PRE_JOINED_ASSET.RULE_ARROW
    }}/>
          </Button>
        </View>

        
        <View className="pre-joined-v1__panel">
          <Image className="pre-joined-v1__panel-bg" source={{
        uri: PRE_JOINED_ASSET.PANEL_BG
    }} resizeMode="cover"/>
          <Image className="pre-joined-v1__hand" source={{
        uri: PRE_JOINED_ASSET.HAND_BADGE
    }}/>

          <View className="pre-joined-v1__top-block">
            <View className="pre-joined-v1__meter-row">
              <View className="pre-joined-v1__meter-num-box">
                <Text className="pre-joined-v1__meter-num" numberOfLines={1}>{currentProgress}</Text>
              </View>
              <Text className="pre-joined-v1__meter-unit" numberOfLines={1}>%</Text>
              <Text className="pre-joined-v1__meter-sub" numberOfLines={1}>
                再得 {remainProgress}% 进度即可解锁
              </Text>
            </View>
            <View className="pre-joined-v1__bar">
              <LinearGradient colors={['#ff0a35', '#fe2b92']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} className="pre-joined-v1__bar-fill" style={{
        width: fillWidth
    }}/>
            </View>
          </View>

          
          <View className="pre-joined-v1__actions">
            <Button className="pre-joined-v1__cta" onPress={() => props.onConfirmJoin()}>
              <LinearGradient colors={['#fe0331', '#fe288b']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} className="pre-joined-v1__cta-bg"/>
              <Text className="pre-joined-v1__cta-text" numberOfLines={1}>{btnText}</Text>
            </Button>
          </View>
        </View>

        
        <View className="pre-joined-v1__notice">
          <NoticeSlider items={props.noticeItems} containerStyle={{
        height: '36rpx'
    }}/>
        </View>

        
        <View className="pre-joined-v1__landmark-section">
          <Image className="pre-joined-v1__landmark-header" source={{
        uri: PRE_JOINED_ASSET.LANDMARK_HEADER
    }} resizeMode="contain"/>
          <View className="pre-joined-v1__landmark-row">
            {props.landmarks.map(landmark => <LandmarkCard key={landmark.cardId} landmark={landmark} onOpenLandmark={props.onOpenLandmark}/>)}
          </View>
        </View>
      </View>
    </View>;
}
export default memo(PreJoinedCardV1);
